import { render, staticRenderFns } from "./PastResultsTable.vue?vue&type=template&id=6301e4c3&"
import script from "./PastResultsTable.vue?vue&type=script&lang=js&"
export * from "./PastResultsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports